import { createContext, useContext, useMemo, useState } from "react";
import { DEFAULT_CURRENCY, formatMoney, pickPrice } from "../lib/money";

// Wraps the app so any view can call `formatPrice(item)` and get the
// correctly-currency-converted display string. We only ship USD today,
// but the surface is ready for a future where NetSuite returns prices
// per-currency on the item.

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children, defaultCurrency = DEFAULT_CURRENCY }) {
  const [currency, setCurrency] = useState(defaultCurrency);
  const [available] = useState([DEFAULT_CURRENCY]); // gate-kept; expand when NS sends more

  const value = useMemo(() => ({
    currency,
    available,
    setCurrency,
    formatPrice: (item) => formatMoney(pickPrice(item, currency)),
    formatAmount: (n) => formatMoney({ amount: Number(n) || 0, currency }),
  }), [currency, available]);

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
